import { render } from "./customerTagsList.vue?vue&type=template&id=2b238f54&scoped=true"
import script from "./customerTagsList.vue?vue&type=script&lang=js"
export * from "./customerTagsList.vue?vue&type=script&lang=js"

import "./customerTagsList.vue?vue&type=style&index=0&id=2b238f54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b238f54"]])

export default __exports__